import React from 'react';
import AuthForm from './AuthForm';

export default function Login() {
  return (
    <section className="container">
      <div className="login-wrapper">
        <AuthForm />
      </div>
    </section>
  );
}
